<script>
export default {
  emits: ['close-dialog'],
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
}
</script>

<template>
  <v-dialog v-model="dialog" max-width="290">
    <v-card>
      <v-card-title class="text-h5"> Coming Soon! </v-card-title>

      <v-card-text>
        This feature is in progress and will be available soon.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="$emit('close-dialog')">
          ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
